export enum GridColumnType {
    Unknown = 'unknown',
    FieldData = 'field-data',
    SubjectProperty = 'subject-property',
    TransferData = 'transfer-data',
    CascadeData = 'cascade-data',
    FeedData = 'feed-data'
}
